import axios from 'axios';

import { API_BASE_URL } from '@shared/config/constants';

export const publicApi = axios.create({
  baseURL: API_BASE_URL,
});

export const privateApi = axios.create({
  baseURL: API_BASE_URL,
});
